const calcOffset = (mainElementInfo, elementInfo) => {
    const offsetTop = (mainElementInfo.bbox.max.y - elementInfo.bbox.max.y) * 100;
    const offsetLeft = -(mainElementInfo.bbox.min.x - elementInfo.bbox.min.x) * 100;
    return { offsetTop, offsetLeft }
}

export default calcOffset;


